import React, { Component } from "react";
import i18n from "i18next";
import axios from "axios";
import "./CalendarWidget.css";
import { APIAddress } from "../lib/apiAddressEnum";
import DataLoader from "../lib/DataLoader";
import Navbar from "../Components/Navbar";
import { ReactComponent as CalendarIcon } from "./../img/icon/calendar.svg";
import { ReactComponent as HamburgerIcon } from "./../img/icon/hamburger.svg";
import {
  regionList,
  countryList,
  region2CountryList,
} from "./../lib/constants";
import { cc2ccy, ccy2cc } from "../lib/utils";
import CalendarBoard from "../Components/Calendar/CalendarBoard";

export default class CalendarWidget extends Component<any, any> {
  dateList: Array<any>;
  constructor(props: any) {
    super(props);
    this.dateList = [
      "News.ECI.-Default",
      "News.ECI.-30",
      "News.ECI.-21",
      "News.ECI.-14",
      "News.ECI.-7",
      "News.ECI.7",
      "News.ECI.14",
      "News.ECI.21",
      "News.ECI.30",
    ];
    this.state = {
      token: this.props.token,
      lang: this.props.lang,
      data: [],
      date: "News.ECI.-Default",
      range: "1",
      region: "ALL",
      country: "ALL",
      mode: "CALENDAR",
      select: "",
      c1month: "",
      c1min: "",
      c1max: "",
      month: "",
      min: "",
      max: "",
    };
  }

  componentDidMount = () => {
    this.LoadCalendar(this.props);
  };

  componentWillReceiveProps(nextProps: any) {
    this.LoadCalendar(nextProps);
  }

  componentWillUnmount() {

  }

  LoadCalendarDot = (props: any) => {
    let base_url = this.props.domain + "/bochkfxwidget/data/eci?";
    let d = new Date(this.state.month);
    let m = d.getMonth();

    let fr =
      d.getFullYear() + (m < 10 ? "0" + m.toString() : m.toString()) + "01";
    d.setMonth(d.getMonth() + 3);
    d.setDate(0);
    let to =
      d.getFullYear() +
      (m < 10 ? "0" + m.toString() : m.toString()) +
      d.getDate();

    let url =
      base_url +
      "&rpp=9" +
      "&fr=" + fr +
      "&to=" + to +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.country +
      "&token=" +
      this.state.token +
      "&_=" +
      new Date().getTime();


    axios.get(url).then((res: any) => {
      if (!this.state.month) {
        if (res.data.data.resptime) {
          let y = res.data.data.resptime.substring(0, 4);
          let m = res.data.data.resptime.substring(4, 6);
          let d = res.data.data.resptime.substring(6, 8);
          this.setState({
            month: y + "-" + m,
            c1month: y + "-" + (m - 1),
            select: new Date(y, parseInt(m) - 1, d),
          });

          let select = new Date(y, parseInt(m) - 1, d);

          // let tmp = new Date(this.state.select.getTime());
          let tmp = new Date(select.getTime());
          tmp.setMonth(tmp.getMonth() - 1);
          let tmp_y: any = tmp.getFullYear().toString();
          let tmp_m: any = (tmp.getMonth() + 1).toString();

          let tmp_m1;
          if (tmp_m.length < 2) tmp_m1 = "0" + (tmp_m - 1);
          let c1min: any = tmp_y + "-" + tmp_m;

          if (tmp_m.length < 2) tmp_m = "0" + tmp_m;
          let min = tmp_y + "-" + tmp_m;

          tmp.setMonth(tmp.getMonth() + 2);
          tmp_y = tmp.getFullYear().toString();
          tmp_m = (tmp.getMonth() + 1).toString();

          if (tmp_m.length < 2) tmp_m1 = "0" + (tmp_m - 1);
          let c1max: any = tmp_y + "-" + tmp_m;

          if (tmp_m.length < 2) tmp_m = "0" + tmp_m;
          let max = tmp_y + "-" + tmp_m;

          this.setState({ min: min, max: max, c1min: c1min, c1max: c1max });
        }
      }

      this.setState({ calendarData: res.data.data.eci });
    });
  };

  LoadCalendar = (props: any) => {
    const param = {
      token: props.token,
      lang: props.lang,
      rpp: 999,
      range: "",
      fr: "",
      to: "",
      cc: this.state.country,
      _: new Date().getTime(),
    };

    let base_url = this.props.domain + "/bochkfxwidget/data/eci?";
    let url =
      base_url +
      "&rpp=9" +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.country +
      "&token=" +
      this.state.token +
      "&_=" +
      new Date().getTime();

    if (this.state.mode === "LIST") {
      param["range"] = this.state.range;
      url =
        base_url +
        "&rpp=9" +
        "&range=" + this.state.range +
        "&lang=" +
        this.props.lang +
        "&cc=" +
        this.state.country +
        "&token=" +
        this.state.token +
        "&_=" +
        new Date().getTime();
    } else {
      let d = new Date(this.state.month);
      let m = d.getMonth();

      let fr =
        d.getFullYear() + (m < 10 ? "0" + m.toString() : m.toString()) + "01";
      d.setMonth(d.getMonth() + 3);
      d.setDate(0);
      let to =
        d.getFullYear() +
        (m < 10 ? "0" + m.toString() : m.toString()) +
        d.getDate();

      url =
        base_url +
        "&rpp=9" +
        "&fr=" + fr +
        "&to=" + to +
        "&lang=" +
        this.props.lang +
        "&cc=" +
        this.state.country +
        "&token=" +
        this.state.token +
        "&_=" +
        new Date().getTime();
    }

    axios.get(url).then((res: any) => {
      if (!this.state.month) {
        if (res.data.data.resptime) {
          let y = res.data.data.resptime.substring(0, 4);
          let m = res.data.data.resptime.substring(4, 6);
          let d = res.data.data.resptime.substring(6, 8);
          this.setState({
            month: y + "-" + m,
            c1month: y + "-" + (m - 1),
            select: new Date(y, parseInt(m) - 1, d),
          });

          let select = new Date(y, parseInt(m) - 1, d);

          // let tmp = new Date(this.state.select.getTime());
          let tmp = new Date(select.getTime());
          tmp.setMonth(tmp.getMonth() - 1);
          let tmp_y: any = tmp.getFullYear().toString();
          let tmp_m: any = (tmp.getMonth() + 1).toString();

          let tmp_m1;
          if (tmp_m.length < 2) tmp_m1 = "0" + (tmp_m - 1);
          let c1min: any = tmp_y + "-" + tmp_m;

          if (tmp_m.length < 2) tmp_m = "0" + tmp_m;
          let min = tmp_y + "-" + tmp_m;

          tmp.setMonth(tmp.getMonth() + 2);
          tmp_y = tmp.getFullYear().toString();
          tmp_m = (tmp.getMonth() + 1).toString();

          if (tmp_m.length < 2) tmp_m1 = "0" + (tmp_m - 1);
          let c1max: any = tmp_y + "-" + tmp_m;

          if (tmp_m.length < 2) tmp_m = "0" + tmp_m;
          let max = tmp_y + "-" + tmp_m;

          this.setState({ min: min, max: max, c1min: c1min, c1max: c1max });
        }
      }

      if (this.state.mode == "LIST") {
        this.setState({ data: { status: "loaded", payload: res.data.data.eci } });
      } else {
        this.setState({ data: { status: "loaded", payload: res.data.data.eci }, calendarData: res.data.data.eci });
      }
    });
  };

  changeSelect = (event: React.FormEvent<HTMLSelectElement>) => {
    let ranges = event.currentTarget.value.split(".");
    this.setState(
      { date: event.currentTarget.value, range: ranges[2], mode: "LIST" },
      () => {
        this.LoadCalendar(this.props);
      }
    );
  };

  getCountryName(fx: string) {
    if (fx) {
      let cc = fx.substring(0, 3);
      return i18n.t("Common.Country." + cc, "");
    }
  }

  createTimeStamp = (time: string) => {
    return (
      time.substring(6, 8) +
      "/" +
      time.substring(4, 6) +
      "/" +
      time.substring(0, 4) +
      " " +
      time.substring(8, 10) +
      ":" +
      time.substring(10, 12)
    );
  };

  changeSelectRegion = (event: React.FormEvent<HTMLSelectElement>) => {
    let country;
    for (let i = 0; i < region2CountryList.length; i++) {
      if (region2CountryList[i].r === event.currentTarget.value) {
        country = region2CountryList[i].c;
      }
    }
    this.setState(
      { region: event.currentTarget.value, country: country },
      () => {
        this.LoadCalendarDot(this.props)
        this.LoadCalendar(this.props);
      }
    );
  };

  // JSX of select list
  RegionList = () => {
    const list = [];
    for (let i = 0; i < regionList.length; i++) {
      list[i] = regionList[i].cd;
    }

    return (
      <select
        onChange={(e) => this.changeSelectRegion(e)}
        value={this.state.region}
      >
        {list.map(function (item, i) {
          return (
            <option key={i} value={item}>
              {i18n.t("Common." + item)}
            </option>
          );
        })}
      </select>
    );
  };

  onPrev = () => {
    let d = new Date(this.state.month);
    d.setMonth(d.getMonth() - 1);
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    this.setState(
      {
        month: y + "-" + (m < 10 ? "0" + m : m),
        c1month: y + "-" + (m - 1 < 10 ? "0" + (m - 1) : m - 1),
      },
      () => {
        this.LoadCalendar(this.props);
      }
    );
  };

  onNext = () => {
    let d = new Date(this.state.month);
    d.setMonth(d.getMonth() + 1);
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    this.setState(
      {
        month: y + "-" + (m < 10 ? "0" + m : m),
        c1month: y + "-" + (m - 1 < 10 ? "0" + (m - 1) : m - 1),
      },
      () => {
        this.LoadCalendar(this.props);
      }
    );
  };

  selectECIDate = (date: Date) => {
    this.setState({ select: date, mode: "CALENDAR" }, () => {
      this.LoadCalendar(this.props);
    });
  };

  filterList() {
    if (this.state.mode === "LIST") {
      return this.state.data.payload;
    } else {
      let list = [];
      if (this.state.data.payload) {
        for (let i = 0; i < this.state.data.payload.length; i++) {
          let event = this.state.data.payload[i];

          let year = parseInt(event.dt.substr(0, 4));
          let month = parseInt(event.dt.substr(4, 2));
          let day = parseInt(event.dt.substr(6, 2));

          let y = this.state.select.getFullYear();
          let m = this.state.select.getMonth() + 1;
          let d = this.state.select.getDate();

          if (year === y && month === m && day === d) {
            list.push(event);
          }
        }
      }
      return list;
    }
  }

  renderCalendar = () => {
    let haveEvents: any = [];
    if (this.state.calendarData !== undefined) {
      for (let i = 0; i < this.state.calendarData.length; i++) {
        let event = this.state.calendarData[i];
        let m = parseInt(event.dt.substr(4, 2));
        let d = parseInt(event.dt.substr(6, 2));
        let e = m.toString() + d.toString()
        if (haveEvents.indexOf(e) < 0) haveEvents.push(e);
      }

      return (
        <div className="ECIWidget-CalendarBoard-Container">
          <CalendarBoard
            haveEvents={haveEvents}
            select={this.state.select}
            min={this.state.min}
            max={this.state.max}
            month={this.state.c1month}
            onPrev={this.onPrev}
            onNext={this.onNext}
            onSelect={this.selectECIDate}
            mode={this.state.mode}
            disablePrev={false}
            disableNext={true}
          />
          <CalendarBoard
            haveEvents={haveEvents}
            select={this.state.select}
            min={this.state.min}
            max={this.state.max}
            month={this.state.month}
            onPrev={this.onPrev}
            onNext={this.onNext}
            onSelect={this.selectECIDate}
            mode={this.state.mode}
            disablePrev={true}
            disableNext={false}
          />
        </div>
      );
    }
  }

  onECIChange = (e: any) => {
    if (this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  };

  render() {
    return (
      <div style={{ fontSize: this.props.fontSize || "100%", marginTop: "50px" }}>
        {/* <Navbar lang={this.props.lang} cc={this.props.cc} /> */}
        <div className="ECIWidget-Content">
          <div className="title">{i18n.t("Calendar.Title")}</div>
          <div className="ECIWidget-Title">
            <div className="select_container">
              <div className="select_container-title">
                {i18n.t("Calendar.Period")}
              </div>
              <select
                onChange={(e) => this.changeSelect(e)}
                value={this.state.date}
              >
                {this.dateList.map(function (item, i) {
                  return (
                    <option key={i} value={item}>
                      {i18n.t(item)}
                    </option>
                  );
                })}
              </select>
              <div
                className="select_container-title"
                style={{ paddingLeft: "5px" }}
              >
                {i18n.t("Common.Currency")}
              </div>
              <this.RegionList />
            </div>
            {/* <div className="ECIWidget-Switch" onClick={this.onSwitch}>
              {this.renderSwitch()}
            </div> */}
          </div>
          {this.renderCalendar()}
          <div className="Calendar-Table">
            <div className="Calendar-Table-Header">
              <div className="Calendar-Table-Col1">
                {i18n.t("Calendar.Country")}
              </div>
              <div className="Calendar-Table-Col2">
                {i18n.t("Calendar.Index")}
              </div>
              <div className="Calendar-Table-Col3">
                {i18n.t("Calendar.AnnounceDate")}
              </div>
              <div className="Calendar-Table-Col4">
                {i18n.t("Calendar.Actual")}
              </div>
              <div className="Calendar-Table-Col5">
                {i18n.t("Calendar.Estimate")}
              </div>
              <div className="Calendar-Table-Col6">
                {i18n.t("Calendar.Previous")}
              </div>
            </div>
            {this.state.data.status === "loaded" &&
              this.filterList().map((item: any, index: number) => {
                return (
                  <div key={index} className={"Calendar-Table-Data"}>
                    <div
                      className="Calendar-Table-Col1"
                      style={
                        index !== this.state.data.payload.length - 1
                          ? { borderBottom: "1px solid #E8E8E8" }
                          : {}
                      }
                    >
                      {this.getCountryName(item.cc)}
                    </div>
                    <div
                      className="Calendar-Table-Col2"
                      style={
                        index !== this.state.data.payload.length - 1
                          ? { borderBottom: "1px solid #E8E8E8" }
                          : {}
                      }
                    >
                      {item.nm}
                    </div>
                    <div
                      className="Calendar-Table-Col3"
                      style={
                        index !== this.state.data.payload.length - 1
                          ? { borderBottom: "1px solid #E8E8E8" }
                          : {}
                      }
                    >
                      {this.createTimeStamp(item.dt)}
                    </div>
                    <div
                      className="Calendar-Table-Col4"
                      style={
                        index !== this.state.data.payload.length - 1
                          ? { borderBottom: "1px solid #E8E8E8" }
                          : {}
                      }
                    >
                      {item.a || "-"}
                    </div>
                    <div
                      className="Calendar-Table-Col5"
                      style={
                        index !== this.state.data.payload.length - 1
                          ? { borderBottom: "1px solid #E8E8E8" }
                          : {}
                      }
                    >
                      {item.c || "-"}
                    </div>
                    <div
                      className="Calendar-Table-Col6"
                      style={
                        index !== this.state.data.payload.length - 1
                          ? { borderBottom: "1px solid #E8E8E8" }
                          : {}
                      }
                    >
                      {item.p || "-"}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}
